import axios from 'axios';
import {
  CreateSmartInterviewInput,
  GetOneSmartInterviewOutput,
  SmartInterviewsBuilder,
} from '../smart-interviews.types';

export const createSmartInterview = (builder: SmartInterviewsBuilder) =>
  builder.mutation<GetOneSmartInterviewOutput, CreateSmartInterviewInput>({
    queryFn: async (data) => {
      const newSmartInterview = await axios.post<GetOneSmartInterviewOutput>(
        `${import.meta.env.REACT_APP_API_URL}/smart-interview-questions`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('id_token')}`,
          },
        }
      );

      if (newSmartInterview.data) {
        await axios.post(
          `${import.meta.env.REACT_APP_API_URL}/smart-interview-questions/${newSmartInterview.data.Id}/generate-voice
`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('id_token')}`,
            },
          }
        );

        return { ...newSmartInterview };
      }

      return { error: { ...newSmartInterview } };
    },
    invalidatesTags: () => [{ type: 'SmartInterviews' }],
  });
